import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Firebase
import * as firebase from "firebase/app";
import "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyCAfL3FBFg2SuryP4QA9O4syhsnS7w_Hyg",
  authDomain: "clipleap-com.firebaseapp.com",
  databaseURL: "https://clipleap-com.firebaseio.com",
  projectId: "clipleap-com",
  storageBucket: "clipleap-com.appspot.com",
  messagingSenderId: "448475350799",
  appId: "1:448475350799:web:ea01ae13e34901cba9207a",
  measurementId: "G-KH35LYDQQQ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// Cookies tool: https://github.com/js-cookie/js-cookie
import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies;

// create global Google Analytics tools (for cookie banner)
Vue.prototype.$initAnalytics = function() {
  // console.log("ANALIZE!");

  // blocks sending data and reseting removed cookies on page refresh
  Vue.prototype.$blockGA = function(){
    window['ga-disable-'+firebaseConfig.measurementId] = true
  }
  // unblocks
  Vue.prototype.$unBlockGA = function(){
    delete window['ga-disable-'+firebaseConfig.measurementId]
  }

  // don't send development data
  if (document.location.hostname == "localhost") {
    Vue.prototype.$blockGA();
  }

  // start analytics
  Vue.prototype.$ga = firebase.analytics();
}

// enable Analytics on first enter and if user allowed it
if ([undefined, "allow"].indexOf(Cookies.get("_cookie_banner")) != -1) {
  Vue.prototype.$initAnalytics();
}

// hide development mode message (tip) in console
Vue.config.productionTip = false

Vue.prototype.$origin = document.location.origin;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
